import React from 'react';
import UserContainer from 'containers/user/UserContainer';
import AppTemplate from 'components/base/template/AppTemplate';
import AppNav from 'components/base/nav/AppNav';

function User() {
  return (
    <AppTemplate
      title={'User'}
      leftSide={<AppNav />}
      mainStyle={{
        // padding: '0 50px',
        padding: '0 0 0 40px',
      }}
    >
      <UserContainer />
    </AppTemplate>
  );
}

export default User;
